import { NgStyle } from '@angular/common'
import { Component, Input } from '@angular/core'
import { Spacing } from '../util'

export interface SpacerComponentInputs {
  height?: Spacing
}

/**
 * Spacer is for adding space between elements vertically
 * Instead of using <br> and style for adding spacing, we can make it as a new component and pass height as a parameter
 */
@Component({
  standalone: true,
  selector: 'ftr-spacer',
  templateUrl: './spacer.component.html',
  imports: [NgStyle],
})
export class SpacerComponent implements SpacerComponentInputs {
  @Input() height: Spacing = Spacing.Regular
}
